import { faCheckCircle, faHourglass, faXmarkCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import { MprcCardHeaderColor, MprcJoinComponents, MprcText } from "components";
import { ExtractFieldErrors } from "components/MprcRequestErrorReport";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

export const CheckOnlineMeetingUrl = () => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const [loading, setLoading] = useState(true);
    const [opened, setOpened] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [sp] = useSearchParams();

    useEffect(() => {

        async function checkLink() {
            const classroomId = sp.get("clrId");
            const componentId = sp.get("compId");

            try {
                if (classroomId && componentId) {
                    const response = await api.v1.instructorManagement.meetingInstructorOnlineUrl({ classroomId, componentId });
                    if (response.data.url != null) {
                        window.open(response.data.url, "");
                        setOpened(true);
                    }
                    else setErrorMessage(response.data.errorMessage);
                }
            }
            catch (e: any) {
                const r = ExtractFieldErrors(e);
                setErrorMessage(r.join('\n'));
            }
            finally {
                setLoading(false);
            }
        }

        checkLink();
    }, []);

    const color = loading ? "info" : opened ? "success" : "error";
    const message = errorMessage ?? t(`Instructor.OpenOnlineMeeting.${loading ? "Loading" : opened ? "Success" : "Error"}`);
    const message2 = opened ? t("Instructor.OpenOnlineMeeting.PopupMessage") : undefined;
    const icon = loading ? faHourglass : opened ? faCheckCircle : faXmarkCircle;

    return (
        <Card sx={{ maxWidth: 600, margin: "0 auto" }}>
            <MprcCardHeaderColor title={t("Instructor.OpenOnlineMeeting.Title")} color={color} />
            <CardContent>
                <Stack justifyContent="start" alignItems="center" direction="row" gap={2}>
                    <MprcText color={color}>
                        <FontAwesomeIcon icon={icon} size="3x" />
                    </MprcText>
                    <Stack direction="column" gap={1} width="100%">
                        <Typography variant="body1" component="div">
                            <MprcJoinComponents components={message.split('\n')} separatorVariant="newline" />
                        </Typography>
                        {message2 &&
                            <Typography variant="caption" component="div">
                                {message2}
                            </Typography>
                        }
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );

};